import React from 'react';
import { string, shape, arrayOf, oneOfType, func } from 'prop-types';
import { Title, Content, Offers, Detail, DetailLabel, DetailText, ChevronRightIcon } from './seller-delivery.styles';
import { isInternationalPrice } from '../../utils';

const parseAddress = data => {
  const {
    address,
    number,
    district,
    city,
    state,
    zipcode
  } = data;
  const value = [];
  if (address && number) value.push(`${address}, ${number}`);
  if (city && state) value.push(`${district ? `${district} - ` : ''}${city}/${state}`);
  if (zipcode) value.push(`CEP: ${zipcode}`);
  return value;
};

const SellerDetail = ({
  seller,
  product,
  onOffersClick
}) => {
  const {
    id,
    description: title,
    deliveryId: delivery,
    details,
    href
  } = seller;
  const showInternationalSeller = isInternationalPrice(product == null ? void 0 : product.price);
  const addressData = parseAddress((details == null ? void 0 : details.address) || {});

  const docSeller = () => {
    return !showInternationalSeller ? {
      label: 'CNPJ',
      id: 'documentNumber',
      value: details == null ? void 0 : details.documentNumber
    } : {
      label: 'ID do Lojista',
      id: 'shippingDocumentNumber',
      value: details == null ? void 0 : details.shippingDocumentNumber
    };
  };

  const detailsParsed = [(details == null ? void 0 : details.legalName) && {
    label: 'Razão Social',
    id: 'legalName',
    value: details == null ? void 0 : details.legalName
  }, docSeller(), addressData.length && {
    label: 'Endereço',
    id: 'address',
    value: parseAddress(details == null ? void 0 : details.address)
  }];
  return /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Title, null, title), /*#__PURE__*/React.createElement(Offers, {
    href: href,
    onClick: e => onOffersClick(e, {
      id,
      delivery
    }),
    "data-testid": "offers-link"
  }, "Veja todas as ofertas dessa loja ", /*#__PURE__*/React.createElement(ChevronRightIcon, null)), detailsParsed.map((detail, index) => /*#__PURE__*/React.createElement(Detail, {
    key: `seller-detail-${index}`,
    "data-testid": "details"
  }, /*#__PURE__*/React.createElement(DetailLabel, null, detail == null ? void 0 : detail.label), Array.isArray(detail == null ? void 0 : detail.value) ? detail == null ? void 0 : detail.value.map(value => /*#__PURE__*/React.createElement(DetailText, {
    "data-testid": "details-value",
    key: `seller-value-${value}`
  }, value)) : /*#__PURE__*/React.createElement(DetailText, null, detail == null ? void 0 : detail.value))));
};

process.env.NODE_ENV !== "production" ? SellerDetail.propTypes = {
  seller: shape({
    id: string,
    deliveryId: string,
    description: string,
    href: string,
    details: shape({
      label: string,
      value: oneOfType([string, arrayOf(string)])
    })
  }),
  product: shape({
    price: shape({
      currency: string
    })
  }),
  onOffersClick: func
} : void 0;
SellerDetail.defaultProps = {
  seller: {
    id: 'magazineluiza',
    deliveryId: 'magazineluiza',
    description: 'Magalu',
    details: {}
  },
  product: {},
  onOffersClick: () => {}
};
export default SellerDetail;